export const removeEmptyProperties = (values) => {
  const payload = {};
  Object.keys(values).forEach((key) => {
    if (values[key]) payload[key] = values[key];
  });
  return payload;
};
